import React from 'react';
import YGAPStyle from './style';
import YGAPImage from '../../../images/Home/YGAP.png';

export default function YGAP() {
	let style = YGAPStyle();
	return (
		<div style={style.outerStyle()}>
			<div style={style.titleRow()}>
				<h1 style={style.mainTitleStyle()}>Your Goals are Pivotal!</h1>
			</div>
			<div style={style.mainContentRow()}>
				<div className={style.imageClasses()} style={style.imageStyle({BG: YGAPImage})}></div>
				<div className={style.rightColClasses()} style={style.rightColStyle()}>
					<div style={style.textCenterer()}>
						<p style={style.YGAPText({removeLargeTopMargin: true, larger: true})}>
							Exercising is a great component to meet your well-being. It helps give an understanding of
							our own bodies and explore our true potential.
						</p>
						<p style={style.YGAPText()}>
							Your training should always be designed around your goals, experiences, and more importantly
							your personal decisions. Designing this program, the principles work for every single
							individual.
						</p>
						<p style={style.YGAPText()}>
							The Programs will give the most efficient way to build quality muscle and create a
							foundation for yourself.{' '}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
